import { cx } from '@linaria/core';
import { useState, useEffect } from 'react';
import { button, burgerCls, tokens, lineCls, topLineCls, middleLineCls, bottomLineCls } from './burger.styles.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const Burger = ({
  size = 20,
  toggled,
  className,
  ...props
}) => {
  const [hasInteracted, setInteracted] = useState(false);
  useEffect(() => {
    return () => {
      setInteracted(true);
    };
  }, [toggled]);
  return /*#__PURE__*/jsx("button", {
    ...props,
    className: button,
    children: /*#__PURE__*/jsxs("div", {
      className: cx(burgerCls, className, hasInteracted && toggled && "cross", hasInteracted && !toggled && "burger"),
      style: tokens.__override({
        size: `${size}px`
      }),
      children: [/*#__PURE__*/jsx("span", {
        role: "none",
        className: cx(lineCls, topLineCls)
      }), /*#__PURE__*/jsx("span", {
        role: "none",
        className: cx(lineCls, middleLineCls)
      }), /*#__PURE__*/jsx("span", {
        role: "none",
        className: cx(lineCls, bottomLineCls)
      })]
    })
  });
};

export { Burger, tokens as burgerTokens };
//# sourceMappingURL=burger.js.map
